export default (el) => {
  const orderButtonEl = document.getElementById('orderButton')
  const checkboxes = el.querySelectorAll('.form-check-input')

  checkboxes.forEach( (checkbox) => {
    checkbox.addEventListener('change', function(event) {
      if (event.target.checked) {
        this.setAttribute("checked", "")
      } else {
        this.removeAttribute("checked")
      }
    });
  })

  orderButtonEl.addEventListener('show.bs.modal', e => {
    const extraEl = document.querySelector('.mp-form-extra')
    const totalEl = document.querySelector('.mp-form-total')
    const totalFinalEl = document.querySelector('.mp-form-total-final')
    const orderFinalEl = document.querySelector('.mp-info-order-final')
    const showExtraEL = document.querySelector('.js-extra')
    const showExtraItemEL = document.querySelector('.js-extra-item')
    const extraProductNames = []
    const extraProductPrices = []

    let finalTotal
    showExtraEL.style.display = 'none'
    showExtraItemEL.innerHTML = ''

    checkboxes.forEach( (checkbox) => {
      if (checkbox.checked) {
        let extraProductName = checkbox.getAttribute('data-extra-product-name')
        let extraProductPrice = checkbox.getAttribute('data-extra-product-price')
        extraProductNames.push(extraProductName)
        extraProductPrices.push(parseInt(extraProductPrice, 10))

        showExtraEL.style.display = 'block'
        showExtraItemEL.innerHTML += '<div>'+ extraProductName +'</div>'
      }
    })

    finalTotal = parseInt(totalEl.value, 10) + extraProductPrices.reduce((a, b) => a + b, 0)

    extraEl.value = extraProductNames.join(', ')
    totalFinalEl.value = finalTotal
    orderFinalEl.textContent = Number((finalTotal).toFixed(1)).toLocaleString() + ' đ'
  })
}
